import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';

const initialState = {};

type TeamMemberAction = {
  type?: string,
  token?: string,
};

type TeamMemberState = {
  MessageId?: string,
  companyId?: string,
  companyName?: string,
  email?: string,
  firstName?: string,
  lastName?: string,
  inviteCode?: string,
  error?: Error,
  expirationDate?: Date,
  fetching?: boolean,
  patching?: boolean,
  success?: boolean,
  type?: 'owner' | 'manager' | 'admin',
}

export default function reduceTeamMembers(
  state: TeamMemberState = initialState,
  action: TeamMemberAction,
) {
  if (!action.type) {
    return state;
  }

  const teamMember = state[action?.token] ?? {};
  const user = state[action?.id] ?? {};

  const actionGroup: string = getActionGroup(action?.type);

  switch (action.type) {
  case ActionTypes.teamMember.post.START:
  case ActionTypes.teamMember.getInvite.START:
    return {
      ...state,
      ...{
        [action?.token ?? 'member']: {
          ...teamMember,
          fetching: true,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.teamMember.resendInvite.START:
    return {
      ...state,
      [actionGroup]: {
        fetching: true,
        success: false,
        error: null,
      },
    };
  case ActionTypes.teamMember.getUser.START:
    return {
      ...state,
      [action?.id]: {
        ...user,
        fetching: true,
        error: null,
        success: false,
      },
    };
  case ActionTypes.teamMember.patchInvite.START:
    return {
      ...state,
      ...{
        [action?.token]: {
          ...teamMember,
          fetching: true,
          success: false,
          error: null,
          patching: true,
          checking: false,
        },
      },
    };
  case ActionTypes.teamMember.patchUser.START:
    return {
      ...state,
      [action?.id]: {
        ...user,
        fetching: true,
        success: false,
        error: null,
        patching: true,
        checking: false,
      },
    };
  case ActionTypes.teamMember.post.SUCCESS:
    return {
      ...state,
      ...{
        [action?.token ?? 'member']: {
          ...teamMember,
          ...(action?.response ?? {}),
          fetching: false,
          success: true,
          error: null,
        },
      },
    };
  case ActionTypes.teamMember.patchInvite.SUCCESS:
    return {
      ...state,
      [action?.token]: {
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
        patching: false,
        checking: false,
      },
    };
  case ActionTypes.teamMember.getInvite.SUCCESS:
    return {
      ...state,
      [action?.token ?? 'member']: {
        ...teamMember,
        ...(action?.response ?? {}),
        success: true,
        fetching: false,
        patching: false,
        error: null,
      },
    };
  case ActionTypes.teamMember.getUser.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...user,
        ...(action?.response ?? {}),
        fetching: false,
        error: null,
        success: true,
      },
    };
  case ActionTypes.teamMember.patchUser.SUCCESS:
    return {
      ...state,
      [action?.id]: {
        ...user,
        ...(action?.response ?? {}),
        fetching: false,
        success: true,
        error: null,
      },
    };
  case ActionTypes.teamMember.post.ERROR:
  case ActionTypes.teamMember.getInvite.ERROR:
  case ActionTypes.teamMember.patchInvite.ERROR:
  case ActionTypes.teamMember.getUser.ERROR:
  case ActionTypes.teamMember.patchUser.ERROR:
    return {
      ...state,
      ...{
        [action?.token ?? 'member']: {
          ...teamMember,
          fetching: false,
          success: false,
          error: action?.error,
        },
      },
    };
  case ActionTypes.teamMember.clear:
    return initialState;

    // no default
  }
  return state;
}
